import { Button, Box } from '@mui/material';
import React, { useCallback } from 'react';
import isNil from 'lodash/isNil';
import { TerminalDetails } from '../../../../../shared/entities/terminal';
import appTheme from '../../../../common/theme/appTheme.json';
import MenuItems from '../../../../common/layout/menu/MenuItems';

interface FulltailViewButtonProps {
  tailDetailsPanelTerminal: TerminalDetails | undefined;
  history: any;
}

export const FulltailViewButton = ({ tailDetailsPanelTerminal, history }: FulltailViewButtonProps) => {
  // Callbacks
  const fullTailViewButtonClickedHandler = useCallback(() => {
    if (tailDetailsPanelTerminal && !isNil(tailDetailsPanelTerminal.datapathUuid)) {
      history.push(`/${MenuItems.fleet}/${tailDetailsPanelTerminal.datapathUuid}`);
    }
  }, [tailDetailsPanelTerminal, history]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '76px' }}>
      <Button
        color="primary"
        variant="contained"
        sx={{
          height: '36px',
          width: '185px',
          lineHeight: '12px',
          fontSize: '14px',
          borderRadius: '20px',
          textTransform: 'uppercase',
          backgroundColor: '#3ec1be',
          borderColor: '#3ec1be',
          color: appTheme.primaryBackgroundColor,
          ':hover': {
            backgroundColor: '#3ec1be',
          },
        }}
        id="full__tail__view__button__root"
        data-test="full-tail-view--button"
        onClick={fullTailViewButtonClickedHandler}
      >
        Full Terminal View
      </Button>
    </Box>
  );
};
